import { render, staticRenderFns } from "./SubmissionOverview.vue?vue&type=template&id=4a761186&scoped=true&"
import script from "./SubmissionOverview.vue?vue&type=script&lang=js&"
export * from "./SubmissionOverview.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a761186",
  null
  
)

export default component.exports